<template>
  <div class="flex items-center">
    <NuxtImg
      v-if="authorPicSrc"
      :src="authorPicSrc"
      :alt="author || 'Unknown Author'"
      class="w-8 h-8 rounded-full mr-2"
      loading="lazy"
    />
    <div>
      <h3 class="font-medium text-sm">{{ author || 'Unknown Author' }}</h3>
      <p class="text-xs text-muted-foreground">@{{ handle || 'unknown' }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  author?: string
  handle?: string
  authorPicSrc?: string
}>()
</script>
